// extracted by mini-css-extract-plugin
module.exports = {"historyRecycleReceives":"HistoryRecycleReceives_historyRecycleReceives__1a4k7","commonCard":"HistoryRecycleReceives_commonCard__zKNoB"};